import {client} from "@/store";
import Vue from "vue";

export default {
	namespaced: true,

	state: {
		appointments: [],
	},

	// sync actions
	mutations: {
		setAppointments(state, data) {
			const userAgent = navigator.userAgent || navigator.vendor || window.opera;
			let device = "other";
			if (/android/i.test(userAgent)) {
				device = "Android";
			}
			data = data.map(appointment => {
				appointment.phone = null;
				appointment.locationUrl = null;
				if(appointment.company == null || appointment.company === false) {
					return appointment;
				}
				if (appointment.company.phone != null && appointment.company.phone.trim() !== "") {
					appointment.phone = appointment.company.phone;
				} else {
					appointment.phone = appointment.company.mobile;
				}
				if (appointment.company.visitingaddress_lat != null && appointment.company.visitingaddress_lat.trim() !== "" && appointment.company.visitingaddress_lng != null && appointment.company.visitingaddress_lng.trim() !== "") {
					// open geo intent on android, otherwise open google maps
					if(device === "Android") {
						appointment.locationUrl = `geo:?q=${appointment.company.visitingaddress_street}+${appointment.company.visitingaddress_streetnumber},${appointment.company.visitingaddress_zipcode}+${appointment.company.visitingaddress_city}`;
					} else {
						appointment.locationUrl = ` https://maps.google.com/maps?q=${appointment.company.visitingaddress_street}+${appointment.company.visitingaddress_streetnumber},${appointment.company.visitingaddress_zipcode}+${appointment.company.visitingaddress_city}`;
					}

				}
				switch (appointment.company.gripp_salutation_id) {
					case "1":
						appointment.company.salutation = "Dhr.";
						break;
					case "2":
						appointment.company.salutation = "Mevr.";
						break;
					default:
						appointment.company.salutation = "Dhr / Mevr.";
						break;
				}
				return appointment;
			});
			state.appointments = data;
		}
	},
	getters: {
	},

	// async actions
	actions: {
		fetchAppointments({ commit, state, dispatch }, data) {
			const query = `
			query ($date: String, $employeeId: ID, $orderBy: String, $orderDirection: String) {
				getAppointments(date: $date, employeeId: $employeeId, orderBy: $orderBy, orderDirection: $orderDirection) {
					id,
					date,
					planned_start_time,
					company {
						id,
						salutation,
						companyname,
						phone,
						visitingaddress_street,
						visitingaddress_streetnumber,
						visitingaddress_zipcode,
						visitingaddress_city,
						visitingaddress_lat,
						visitingaddress_lng
					}
				}
			}`;
			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, data).then(result => {
					commit('setIdle', null, { root: true });
					commit('setAppointments', result.getAppointments);
					resolve(result.getAppointments);
				});
			});
		}
	}
};
